import ReactDOM from "react-dom/client";
import { lazy, Suspense } from "react";
import reportWebVitals from "reportWebVitals";

import { ContactUs } from "shared/components/Auth/ContactUs";
import SpinLoader, {
  LOADER_COLOR_DARK,
  LOADER_SIZE_LARGE,
  POSITION_ABSOLUTE,
} from "shared/components/SpinLoader";
import LoginForm from "shared/components/Auth/LoginForm";
import { RestorePass } from "shared/components/Auth/RestorePass";
import { UnconnectedErrorBoundary as ErrorBoundary } from "shared/components/ErrorBoundary";

import { initSentry } from "shared/helpers/utils";

import "i18n";

import "@sharedAssets/global.scss";
import "@brandAssets/scss/main.scss";
import { SITE_IDENTITY } from "shared/constants/envVariables";

const formsMap = {
  cupidlee: lazy(
    () => import("shared/components/Auth/RegistrationFormRedesign")
  ),
  amourforme: lazy(
    () => import("shared/components/Auth/RegistrationFormAmourforme")
  ),
};

const LazyForm =
  formsMap[SITE_IDENTITY] ??
  lazy(() => import("shared/components/Auth/RegistrationForm"));

initSentry();

const container = document.getElementById("registration");

if (container) {
  ReactDOM.createRoot(container).render(
    <ErrorBoundary>
      <Suspense
        fallback={
          <SpinLoader
            color={LOADER_COLOR_DARK}
            size={LOADER_SIZE_LARGE}
            position={POSITION_ABSOLUTE}
            withBlur={true}
          />
        }
      >
        <LazyForm />
      </Suspense>
    </ErrorBoundary>
  );
}

if (document.getElementById("login")) {
  ReactDOM.createRoot(document.getElementById("login")).render(
    <ErrorBoundary>
      <LoginForm />
    </ErrorBoundary>
  );
}

if (document.getElementById("restore")) {
  ReactDOM.createRoot(document.getElementById("restore")).render(
    <ErrorBoundary>
      <RestorePass />
    </ErrorBoundary>
  );
}

if (document.getElementById("contact_us")) {
  ReactDOM.createRoot(document.getElementById("contact_us")).render(
    <ErrorBoundary>
      <ContactUs />
    </ErrorBoundary>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
